/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.7",
    versionName: "0.2.0-nightly.2025.7.7",
    versionChannel: "nightly",
    buildDate: "2025-07-07T00:08:15.080Z",
    commitHash: "8e5f01c42f1884907d02c4c78131a69d2055172a",
};
